import React from 'react';
import { Link } from 'react-router-dom';
import './AboutUs.css';
import { LoginNavbar } from '../../components/layout/Navbar';
import { useTranslation } from 'react-i18next';
import missionImg from '../../assets/images/timesheet-aboutus-mission.png';
import visionImg from '../../assets/images/timesheet-aboutus-vision.png';
import valuesImg from '../../assets/images/timesheet-aboutus-values.png';

const Footer = ({ className, children }) => (
  <footer className={className || 'footer'}>
    {children}
  </footer>
);

const AboutUs = () => {
  const { t } = useTranslation();

  return (
    <>
      <LoginNavbar />
      <div className="about-container">
        <div className="about-back-button">
          <Link to="/login" className="back-button">
            ← {t('about.backToLogin')}
          </Link>
        </div>
        <div className="about-hero">
          <div className="about-hero-content">
            <h1 className="about-title">{t('about.title')}</h1>
            <p className="about-subtitle">{t('about.subtitle')}</p>
          </div>
        </div>

        <div className="about-content">
          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">{t('about.mission.title')}</h2>
              <p className="about-section-text">{t('about.mission.text')}</p>
            </div>
            <div className="about-section-image">
              <img src={missionImg} alt={t('about.mission.title')} className="about-image-native" />
            </div>
          </div>

          <div className="about-section reverse">
            <div className="about-section-image">
              <img src={visionImg} alt={t('about.vision.title')} className="about-image-native" />
            </div>
            <div className="about-section-content">
              <h2 className="about-section-title">{t('about.vision.title')}</h2>
              <p className="about-section-text">{t('about.vision.text')}</p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">{t('about.whatWeDo.title')}</h2>
              <p className="about-section-text">{t('about.whatWeDo.text')}</p>
              <div className="about-features">
                <div className="about-feature">
                  <div className="about-feature-icon">⏰</div>
                  <h3>{t('about.features.timeTracking.title')}</h3>
                  <p>{t('about.features.timeTracking.description')}</p>
                </div>
                <div className="about-feature">
                  <div className="about-feature-icon">💰</div>
                  <h3>{t('about.features.expenseManagement.title')}</h3>
                  <p>{t('about.features.expenseManagement.description')}</p>
                </div>
                <div className="about-feature">
                  <div className="about-feature-icon">📊</div>
                  <h3>{t('about.features.analyticsReporting.title')}</h3>
                  <p>{t('about.features.analyticsReporting.description')}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="about-section reverse">
            <div className="about-section-image">
              <img src={valuesImg} alt={t('about.values.title')} className="about-image-native" />
            </div>
            <div className="about-section-content">
              <h2 className="about-section-title">{t('about.values.title')}</h2>
              <div className="about-values">
                <div className="about-value">
                  <h3>{t('about.values.innovation.title')}</h3>
                  <p>{t('about.values.innovation.description')}</p>
                </div>
                <div className="about-value">
                  <h3>{t('about.values.reliability.title')}</h3>
                  <p>{t('about.values.reliability.description')}</p>
                </div>
                <div className="about-value">
                  <h3>{t('about.values.userExperience.title')}</h3>
                  <p>{t('about.values.userExperience.description')}</p>
                </div>
                <div className="about-value">
                  <h3>{t('about.values.customerSuccess.title')}</h3>
                  <p>{t('about.values.customerSuccess.description')}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="about-cta">
            <h2>{t('about.cta.title')}</h2>
            <p>{t('about.cta.subtitle')}</p>
            <Link to="/login" className="about-cta-button">
              {t('about.cta.button')}
            </Link>
          </div>
        </div>
      </div>
      <Footer className="about-footer">{t('layout.footer')}</Footer>
    </>
  );
};

export default AboutUs;
